import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../../contexts/LanguageContext';
import NewsPhotoPicker from './NewsPhotoPicker';
import { EMPTY_PHOTO_STATE, NEWS_SHORT_DESCRIPTION_MAX } from '../utils/newsUtils';

export const EMPTY_PLANNING_NEWS = { publish: 0, shortDescription: '', detailDescription: '', photo: EMPTY_PHOTO_STATE };

export const toPlanningNewsForm = (news) => (news ? { publish: 1, shortDescription: news.shortDescription || '', detailDescription: news.detailDescription || '', photo: EMPTY_PHOTO_STATE } : EMPTY_PLANNING_NEWS);

const PlanningNewsSection = ({ value, onChange, existingNews, loading = false, disabled = false }) => {
    const { th } = useLanguage();
    const setField = (field, fieldValue) => onChange({ ...value, [field]: fieldValue });
    const published = Number(value.publish) === 1;

    return (
        <div className="mt-4 pt-4" style={{ borderTop: '1px solid var(--surface-border)' }}>
            <div className="flex align-items-center gap-2 mb-3">
                <i className="pi pi-megaphone" />
                <span className="font-semibold">{th('lmsNews.planning.publishQuestion')}</span>
                {loading && <ProgressSpinner style={{ width: '1rem', height: '1rem' }} strokeWidth="6" />}
            </div>

            <div className="flex gap-4 mb-3">
                {[1, 0].map((option) => (
                    <div key={option} className="flex align-items-center">
                        <RadioButton inputId={`planningNewsPublish${option}`} name="planningNewsPublish" value={option} onChange={(e) => setField('publish', e.value)} checked={Number(value.publish) === option} disabled={disabled || loading} />
                        <label htmlFor={`planningNewsPublish${option}`} className="ml-2 cursor-pointer">
                            {option === 1 ? th('common.yes', { fallback: 'Evet' }) : th('common.no', { fallback: 'Hayır' })}
                        </label>
                    </div>
                ))}
            </div>

            {existingNews && !published && <small className="block mb-3 text-orange-600">{th('lmsNews.planning.removeWarning')}</small>}

            {published && (
                <div className="grid p-fluid">
                    <div className="col-12 md:col-5">
                        <div className="field">
                            <label>{th('lmsNews.form.fields.photo')}</label>
                            <NewsPhotoPicker news={existingNews} value={value.photo} onChange={(photo) => setField('photo', photo)} disabled={disabled} />
                        </div>
                    </div>
                    <div className="col-12 md:col-7">
                        <div className="field">
                            <label htmlFor="planningNewsShortDescription">{th('lmsNews.form.fields.shortDescription')}</label>
                            <InputTextarea
                                id="planningNewsShortDescription"
                                value={value.shortDescription}
                                maxLength={NEWS_SHORT_DESCRIPTION_MAX}
                                rows={3}
                                autoResize
                                disabled={disabled}
                                onChange={(e) => setField('shortDescription', e.target.value)}
                            />
                            <small className="text-color-secondary flex justify-content-end">
                                {value.shortDescription.length} / {NEWS_SHORT_DESCRIPTION_MAX}
                            </small>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="field mb-0">
                            <label htmlFor="planningNewsDetailDescription">{th('lmsNews.form.fields.detailDescription')}</label>
                            <InputTextarea id="planningNewsDetailDescription" value={value.detailDescription} rows={4} autoResize disabled={disabled} onChange={(e) => setField('detailDescription', e.target.value)} />
                        </div>
                    </div>
                    <div className="col-12">
                        <small className="text-color-secondary">
                            <i className="pi pi-info-circle mr-1" />
                            {th('lmsNews.planning.autoFieldsHint')}
                        </small>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PlanningNewsSection;
